export default __webpack_public_path__ + "static/media/clickTooltip.7a6d46ba.png";